import { config, loadConfig } from '@/config';
import { SocketInstance, SocketOptions } from '@/SocketInstance';
import store from '@/store';

let instance: SocketInstance;

export const getIoInstance = (): SocketInstance => instance;

export const createSocketInstance = async (): Promise<SocketInstance> => {
  if (instance) {
    return instance;
  }

  // Wait until it finishes fetching the config file.
  await loadConfig();

  const socketOptions: SocketOptions = {
    url: config.server,
    onDisconnect: () => {
      store.dispatch(`notification/initNotificationDialog`, 'Connection problems');
    },
    timeout: config.connectionErrorTimeout,
  };
  instance = new SocketInstance(socketOptions);
  return instance;
};
